export const STATUS = {
  PLANTED: "planted",
  HARVESTED: "harvested",
  DISCARDED: "discarded",
};

export const STATUS_LABEL = {
  [STATUS.PLANTED]: "Planted",
  [STATUS.HARVESTED]: "Harvested",
  [STATUS.DISCARDED]: "Discarded",
};

export const UNSAVED_FILTER_LABEL = "(Unsaved)";

export const GROUP_UNHARVESTED = "group:unharvested";
export const GROUP_HARVESTED = "group:harvested";
export const BAY_U_PREFIX = "bayU:";
export const BAY_H_PREFIX = "bayH:";
